var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21.394 23.134",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M1.619 6.423A1.631 1.631 0 000 8.059v13.456a1.628 1.628 0 003.255 0V8.059a1.634 1.634 0 00-1.636-1.636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 6",
    d: "M10.758 0a1.631 1.631 0 00-1.619 1.636v19.88a1.628 1.628 0 003.255 0V1.636A1.634 1.634 0 0010.758 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 8",
    d: "M19.775 13.525a1.634 1.634 0 00-1.636 1.636v6.354a1.628 1.628 0 003.255 0v-6.354a1.631 1.631 0 00-1.619-1.636"
  })));
}

export default SvgChart;